/**
 * Single source of truth for KPI favorability values and the wording shown for them
 * (ER-12468 / MDP-428, ruling D5: one wording pair everywhere).
 */
export const MORE_IS_FAVORABLE = "MORE_IS_FAVORABLE";
export const LESS_IS_FAVORABLE = "LESS_IS_FAVORABLE";

export const FAVORABILITY_VALUES = [MORE_IS_FAVORABLE, LESS_IS_FAVORABLE];

export const FAVORABILITY_COPY = {
  [MORE_IS_FAVORABLE]: {
    label: "More is favorable",
    helper: "Actuals that are higher are better",
  },
  [LESS_IS_FAVORABLE]: {
    label: "Less is favorable",
    helper: "Actuals that are lower are better",
  },
};
